import styled from "styled-components";

export const PressInfoSearchWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
`;
